export default "__VITE_ASSET__BB710VC8__"